import axios from "axios";
import { ICheckDrivingLicenceRequest, ICreateAttachmentParams, IEditAttachmentParams, IUpdateDocumentStatusRequest } from "../../types";

export const getDossiersTemplates = () => {
    return axios.get("/dossiers/templates");
}

export const getDossiersByOwner = (id: string) => {
    return axios.get("/dossiers", { params: { owner: id}});
}

export const readAttachmentPage = (owner: string, dossier: string, attachment: string, type: string) => {
    return axios.get(`/dossiers/attachments/attachment/pages/page/${owner}/${dossier}/${attachment}/${type}`);
};

export const readAttachmentPageAsync = async (owner: string, dossier: string, attachment: string, type: string) => {
    const resp = await axios.get(`/dossiers/attachments/attachment/pages/page/${owner}/${dossier}/${attachment}/${type}`);
    return resp.data;
}

export const createAttachment = (params: ICreateAttachmentParams) => {
    let formData = new FormData();
    formData.append("request", new File([JSON.stringify(params.request)], "request.json", { type: "application/json"}));
    if(!!params.front) formData.append("front", params.front);
    if(!!params.back) formData.append("back", params.back);
    if(!!params.selfie) formData.append("selfie", params.selfie);

    return axios.post("/dossiers/attachments", formData, {headers: { "Content-Type": "multipart/form-data" }});
}

export const updateAttachment = (params: IEditAttachmentParams | undefined) => {
    
    let formData = new FormData();
    //formData.append("request", new File([JSON.stringify(params.request)], "request.json", { type: "application/json"}));
    formData.append("request", JSON.stringify(params?.request));
    if(!!params?.front) formData.append("front", params.front);
    if(!!params?.back) formData.append("back", params.back);
    if(!!params?.selfie) formData.append("selfie", params.selfie);

    return axios.put("/dossiers/attachments", formData, { headers: { "Content-Type": "multipart/form-data"} });

}

export const checkDrivingLicence = ({ queryKey}: any) => {
    const [_key, checkDrivingLicenceQueryFields] = queryKey;
    return axios.get(`/dossiers/attachments/attachment/${checkDrivingLicenceQueryFields.owner}/${checkDrivingLicenceQueryFields.dossier}/${checkDrivingLicenceQueryFields.attachment}/check`);
}

export const updateAttachmentStatus = (request: IUpdateDocumentStatusRequest) => {
    return axios.put("/dossiers/attachments/attachment/status", request);
}

export const updateDossierStatus = (request: IUpdateDocumentStatusRequest) => {
    return axios.put("/dossiers/dossier/status", request);
}

export const getBundleStatusAsync = async (uuid: string) => {
    const resp = await axios.get(`/dossiers/bundle/status/${uuid}`);
    return resp.data;
}